import { FC, Fragment } from "react";
import { Divider, Stack } from "@mui/material";
import { explainWithAiLoadingSelector } from "@/store/explain-with-ai/selectors/loading/explainWithAiLoadingSelector";
import { ExplainWithAiLoading } from "@/components/common/explain-with-ai-drawer/components/common/ExplainWithAiLoading";
import { useAppSelector } from "@/store/hooks";
import { ExplainWithAiAnomaliesCount } from "@/components/common/explain-with-ai-drawer/components/body/components/ExplainWithAiAnomaliesCount";
import { ExplainWithAiAnomaliesSummary } from "@/components/common/explain-with-ai-drawer/components/body/components/ExplainWithAiAnomaliesSummary";
import { ExplainWithAiIncreaseAnomalies } from "@/components/common/explain-with-ai-drawer/components/body/components/increase-trends/ExplainWithAiIncreaseAnomalies";
import { ExplainWithAiSpikeAnomalies } from "@/components/common/explain-with-ai-drawer/components/body/components/spike-trends/ExplainWithAiSpikeAnomalies";
import { ExplainWithAiDecreaseAnomalies } from "@/components/common/explain-with-ai-drawer/components/body/components/decrease-trends/ExplainWithAiDecreaseAnomalies";
import { Dates } from "@/services/cloudchipr.api";
import { isExplainWithAiOutDateRangesByDatesSelector } from "@/store/explain-with-ai/selectors/isExplainWithAiOutDateRangesByDatesSelector";

interface ExplainWithAiAnomaliesProps {
  index: number;
  localLoading?: boolean;
  dates?: Dates;
}

export const ExplainWithAiAnomalies: FC<ExplainWithAiAnomaliesProps> = ({
  index,
  localLoading,
  dates,
}) => {
  const loading = useAppSelector((state) =>
    explainWithAiLoadingSelector(state, index),
  );

  const isOutRangesDates = useAppSelector((state) =>
    isExplainWithAiOutDateRangesByDatesSelector(state, dates),
  );

  if (isOutRangesDates) {
    return null;
  }
  return (
    <Stack py={1.5}>
      {loading || localLoading ? (
        <ExplainWithAiLoading />
      ) : (
        <Fragment>
          <Divider sx={{ mb: 1.5 }} />
          <ExplainWithAiAnomaliesCount index={index} />
          <ExplainWithAiAnomaliesSummary index={index} />
          <Stack spacing={1.5}>
            <ExplainWithAiIncreaseAnomalies index={index} />
            <ExplainWithAiSpikeAnomalies index={index} />
            <ExplainWithAiDecreaseAnomalies index={index} />
          </Stack>
        </Fragment>
      )}
    </Stack>
  );
};
